import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const passwordChangedContainer = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const successBg = style({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 60,
  height: 60,
  background: themeVars.container.prominent.background.idle,
  borderRadius: 9999,
  margin: space.s24,
});

export const linkButton = style({
  width: '100%',
  marginTop: space.s24,
});
